import React, { useEffect, useState } from "react";
import { CrudModal, AutoComplete } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box } from "@mui/material";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import { createEmail, updateEmail } from "../../services/email.service";
import { getHrAdminAccountsUsers } from "../../services/user.service";

const AddEmail = ({
    handleCloseDrawer,
    formType,
    selectedData,
    setOpenDrawer,
    GetEmailData,
}) => {
    const dispatch = useDispatch();
    const disabled = formType === "view";
    const [userData, setUserData] = useState([]);

    const [initialValues, setInitialValues] = useState({
        userId: "",
        email: "",

    });

    const validationSchema = yup.object().shape({
        userId: yup.string().required("User Name Required *"),
        email: yup.string().email("Invalid email").required("Email is required *"),
    });

    useEffect(() => {
        if (formType === "edit" || formType === "view") {
            setInitialValues({
                userId: selectedData.userId || selectedData.name || "",
                email: selectedData.email || "",

            });
        }
    }, [formType, selectedData]);

    const onSubmit = async (values) => {
        try {
            const apiMethod =
                formType === "edit"
                    ? updateEmail(selectedData._id, values)
                    : createEmail(values);
            const res = await apiMethod;
            setOpenDrawer(false);
            GetEmailData();
            dispatch(showToast({ message: res.message, type: "success" }));
        } catch (error) {
            dispatch(showToast({ message: error.data?.message || "Error occurred", type: "error" }));
        }
    };

    const GetUserData = async () => {
        try {
            const res = await getHrAdminAccountsUsers();
            const modifiedData =
                res?.data.map((e) => ({
                    ...e,
                    label: e.name,
                    id: e._id,
                })) || [];
            setUserData(modifiedData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetUserData();
    }, []);

    return (
        <CrudModal
            title={
                formType === "add"
                    ? "Add Email"
                    : formType === "edit"
                        ? "Edit Email"
                        : "View Email"
            }
            open={true}
            handleClose={handleCloseDrawer}
            maxWidth="xs"
        >
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
                enableReinitialize={true}
            >
                {({ touched, errors, setFieldValue, values }) => (
                    <div className="formContainer" style={{ height: "fit-content" }}>
                        <Form>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        User Name
                                    </Typography>
                                    <AutoComplete
                                        options={userData}
                                        value={userData.find(u => u.id === values.userId) || null}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, v) => {
                                            setFieldValue("userId", v ? v.id : "");
                                        }}
                                        placeholder="Select User"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.userId && errors.userId ? errors.userId : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Email
                                    </Typography>
                                    <Field
                                        name="email"
                                        className="InputField"
                                        placeholder="Enter Email"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.email && errors.email ? errors.email : null}
                                    </div>
                                </Grid>
                                {/* <Grid size={{ xs: 12, sm: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Description
                                    </Typography>
                                    <Field
                                        name="description"
                                        className="InputField"
                                        placeholder="Enter Description"
                                        disabled={disabled}
                                    />
                                    <div className="form-error">
                                        {touched.description && errors.description
                                            ? errors.description
                                            : null}
                                    </div>
                                </Grid> */}
                                <Grid size={{ xs: 12 }} mt={2}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "20px",
                                        }}
                                    >
                                        <Button
                                            className="cancelButton"
                                            onClick={() => setOpenDrawer(false)}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="addButton"
                                            sx={{ display: formType === "view" ? "none" : "flex" }}
                                        >
                                            {formType === "edit" ? "Update" : "Save"}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    </div>
                )}
            </Formik>
        </CrudModal>
    );
};

export default AddEmail;
